import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { StorageService } from 'src/app/utils/storage.service';
import { Router } from '@angular/router';

/**
  * @author Ministerio de cultura
  * @createdate 2024-10-14
  * Interceptor que se encarga de mostrar las notificaciones de posibles errores.
*/
@Injectable()
export class AlertInterceptor implements HttpInterceptor {

  constructor(
    private messageService: MessageService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        // Evitar mostrar toast para 404 con mensaje específico
        if (error.status === 404 && error.error && typeof error.error === 'string') {
          const mensaje = error.error?.toLowerCase?.();
          if (mensaje?.includes('no se encontraron archivos para este avance')) {
            // No mostrar nada
            return throwError(() => error);
          }
        }

        let detail = 'Error de procedimiento';
        let summary = 'Error';
        let severity = 'error';
        let life = 3000; // duración por defecto
        let closable = false; // sin botón de cerrar por defecto

        switch (error.status) {
          case 0:
            detail = 'No se pudo conectar con el servidor. Verifique su conexión a internet.';
            break;
          case 400:
            detail = error.error?.message || 'Error de procedimiento';
            life = 12000;
            closable = true;
            break;
          case 401:
            detail = error.error?.message || 'No autorizado. Por favor, inicie sesión nuevamente.';
            break;
          case 403:
            detail = error.error?.message || 'Acceso denegado. No tiene permisos para realizar esta acción.';
            break;
          case 404:
            detail = error.error?.message || 'Recurso no encontrado.';
            life = 12000;
            closable = true;
            break;
          case 409:
            detail = error.error?.message || 'Conflicto en la solicitud. Verifique los datos enviados.';
            break;
          case 500:
            detail = error.error?.message || 'Error interno del servidor. Intente más tarde.';
            break;
          default:
            detail = error.error?.message || error.error || 'Error de procedimiento';
            break;
        }

        this.messageService.add({
          severity,
          summary,
          detail,
          life,
          closable
        });

        return throwError(() => error);
      })
    );
  }
}